export default {
    en: [{value: 'Male', label: 'Male'},
        {value: 'Female', label: 'Female'}],
    zh_CN: [{value: 'Male', label: '男性'},
        {value: 'Female', label: '女性'}],
    zh_HK: [{value: 'Male', label: '男性'},
        {value: 'Female', label: '女性'}]
}
